(function ($, Global) {
	var hrefKeyword = null;
    function ArticleComponent() {
        // Déclaration class objet
    }

	ArticleComponent.prototype.initEvents = function () {
		this.publishers();
	}

    ArticleComponent.prototype.publishers = function () {
        var self = this;
        $(window).on('scroll', function () {
            var handleShowOrHide = '';
            if (
                self.visibleInViewport(document.querySelector('.articles-supplementary'))
                &&
                self.visibleInViewport(document.querySelector('article .article-body'))
            ) {
                handleShowOrHide = 'addClass';
            } else {
                handleShowOrHide = 'removeClass';
            }
            $('.btn-daily')[handleShowOrHide]('show');
        });
        $(document).ready(function () {
            if (!$('.btn-daily').exists() || ($(window).width() < Global.viewports.md)) return;

            var articleBodyHeight = $('article .article-body').height();
            var keywordsHeight = $('.sidenav-content').height();
            var btnDailyHeight = $('.btn-daily').height();

            if (articleBodyHeight < (keywordsHeight + btnDailyHeight)) {
                $('.btn-daily').addClass('reverse');
            }
        });
		$(document).on('click', 'article [data-toggle="popover"]', function (e) {
			if ($(window).width() <= Global.viewports.md) {
				e.preventDefault();
			}
        });

        $(document).on('show.bs.popover', 'article [data-toggle="popover"]', function (e) {
            if ($(window).width() <= Global.viewports.md) {
                hrefKeyword = $(this).attr('href');
            }
        });

        $(document).on('shown.bs.tooltip', 'article [data-toggle="tooltip"]', function (e) {
            var $this = $(this);
            var tooltipId = $this.attr('aria-describedby');
            var $tooltip = $('#' + tooltipId);
            var tooltipOffset = $tooltip.offset();

            if (tooltipOffset) {
                if (tooltipOffset.left && (tooltipOffset.left + $tooltip.width()) > $(window).width()) {
                    $tooltip.css({
                        'left': $(window).width() - $tooltip.outerWidth(),
                        'top': tooltipOffset.top + $tooltip.outerHeight()
                    })
                }
            }            
        });

		$(document).on('click touchstart', '.popover-body', function () {
			if ($(window).width() <= Global.viewports.md && hrefKeyword) {
				window.location.href = hrefKeyword;
			}
		});
    }

    ArticleComponent.prototype.visibleInViewport = function (el) {
        if (!el) return false;

        var rect = el.getBoundingClientRect();
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;

        return rect.top <= windowHeight && rect.top + rect.height >= 0;
    }

	Global.ArticleComponent = ArticleComponent;
}(jQuery, window));